import React from "react";
import { ComboBox, DialogType, IColumn, IComboBox, IComboBoxOption, ICommandBarItemProps, Icon, IconButton, Modal, Stack, TextField, TooltipHost } from "@fluentui/react";
import { useEffect, useState } from "react";
import { HeadingBar } from "../../../components/Generic/HeadingBar"
import { TableBase } from "../../../components/Table/TableBase"
import { IException } from "../../../interfaces/base/IBase";
import { ICreateRoster, IRoster } from "../../../interfaces/IRoster";
import RosterService from "../../../services/rosterService";
import { baseSearch, splitExceptionDetail, stackTokens, stackTokensHorizontal, _initialFilter } from "../../../utils/Helper/helper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
//import ThemeBase from "../../../utils/Theme/themeBase";
import { useBoolean } from '@fluentui/react-hooks';
import { ModalHelper } from "../../../utils/Helper/modalHelper";
import { ButtonForm } from "../../../components/Generic/buttonForm";
import { IComboOptions } from "../../../components/Generic/combo";
import { DialogBase } from "../../../components/Dialog/DialogBase";
import PersonaService from "../../../services/PersonaService";
import { useSearchParams } from "react-router-dom";
import { Ifilter } from "../../../interfaces/IFilter";
import { PanelRosterCrear } from "./crear/PanelRosterCrear";
import { PanelRosterActualizar } from "./actualizar/PanelRosterActualizar";
import { PanelRosterEliminar } from "./eliminar/PanelRosterEliminar";
import { TableComponent } from "../../../components/Table/TableComponent";
import { IButtonGroup } from "../../../interfaces/base/ITable";
import { UseRoster } from "./UseRoster";
import { useMakeStyle } from '../../../functions/BaseStyle';
import ThemeBase from "../../../utils/Theme/themeBase";



const initialRoster = () => {
    let t: ICreateRoster = {
        codigo: null
    };

    return t;
}

export const ListarRoster = () => {
    const [roster, setRoster] = useState<IRoster[]>([]);
    const [hidden, setHidden] = useState(false);
    const [column, setColumn] = useState<IColumn[]>([]);
    const [form, setForm] = useState<ICreateRoster>(initialRoster());
    const [dataEditRoster, setDataEditRoster] = useState<IRoster>(null!);
    const [guardia, setGuardia] = useState<IComboOptions[]>([]);
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const { items, loading, pagination, handleResetUpdate, onChangeSearch, setDataEdit, dataEdit } = UseRoster()
    const [isOpenCrear, { setTrue: openPanelCrear, setFalse: closePanelCrear }] = useBoolean(false);
    const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
    const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
     const style = useMakeStyle();

    /* Modal */
    const [isOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);

    /* Dialog */
    const [hideEliminar, { toggle: toggleEliminar }] = useBoolean(true);
    const [selId, setSelId] = useState<string | undefined>(undefined);

    /* Filter */
    const [searchParam, setSearchParam] = useSearchParams();
    const [filter, setFilter] = useState<Ifilter>(_initialFilter);

    /* Hook */
    // useEffect(() => {
    //     // setTitleColumn();
    //     setup();
    // }, []);
    // useEffect(() => {
    //     if (isOpen === true) {
    //         dataGuardia();
    //     }
    // }
    //     , [isOpen]);

    // useEffect(() => {
    //     if (filter.search != null) {
    //         setup();
    //     }
    // }, [filter]);

    /* Api */
    // const dataRoster = () => {
    //     setRoster([]);
    //     RosterService.all(filter).then(res => {
    //         setRoster(res.data);
    //         setHidden(true);
    //     }).catch((e: IException) => {
    //         alert(splitExceptionDetail(e));
    //         setHidden(true);
    //     })
    // }

    const dataGuardia = () => {
        PersonaService.comboGuardiaProgramacion(_initialFilter())
            .then((response: any) => {
                if (response.status == 200) {
                    setGuardia(response.data);
                }
            })
            .catch((e: Error) => {
                console.log(e);
            });
    }

    const crearRoster = () => {
        RosterService.crearRoster(form).then(res => {
            if (res.status == 200) {
                alert('Se registró correctamente');
                hideModal();
                // setup();
            }
        }).catch((e: IException) => {
            alert(splitExceptionDetail(e));
            setHidden(true);
        })
    }

    const eliminarRoster = () => {
        if (form.id) {
            RosterService.elimminarRoster(form.id).then(res => {
                if (res.status == 200) {
                    alert('Se eliminó correctamente');
                    toggleEliminar();
                    // setup();
                }
            }).catch((e: IException) => {
                alert(splitExceptionDetail(e));
                setHidden(true);
            })
        }
    }
    /* Event */


    /* Function */
    // const setup = () => {
    //     dataRoster();

    // }

    const _columns: IColumn[] = [
        {
            key: "numeracion",
            name: "N°",
            fieldName: "numeracion",
            minWidth: 30,
            maxWidth: 50,
            onRender: (item, index) => <>{(index ?? 0) + 1}</>
        },
        {
            key: "codigo",
            name: "Código",
            fieldName: "codigo",
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isPadded: true,
        },
        {
            key: "diasLaborables",
            name: "Días Trabajo",
            fieldName: "diasLaborables",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
        },
        {
            key: "diasDescanso",
            name: "Días Descanso",
            fieldName: "diasDescanso",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
        },
        {
            key: "turnoDia",
            name: "Turno día",
            fieldName: "turnoDia",
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
        },
        {
            key: "turnoNoche",
            name: "Turno noche",
            fieldName: "turnoNoche",
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
        },
        {
            key: "guardia",
            name: "Guardia asignada",
            fieldName: "guardia",
            minWidth: 100,
            maxWidth: 240,
            isResizable: true,
        },
        {
            key: "usuarioRegistra",
            name: "Usuario Registra",
            fieldName: "usuarioRegistra",
            minWidth: 120,
            maxWidth: 180,
            isResizable: true,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 80,
            maxWidth: 100,
            fieldName: "opciones",
            isResizable: true,
            onRender: (item: any) => renderOpciones(item)
        },
    ]

    function renderOpciones(item: IRoster) {
        return (
          <div style={{
            display: "flex",
            gap: "10px",
          }}>
            <TooltipHost content={`Editar`}>
              <Icon
                iconName="Edit"
                style={{
                  cursor: "pointer",
                }}
                className={ThemeBase.classes.iconFont}
                onClick={() => {
                  setDataEdit(item);
                  openPanelEditar();
                }}
              />
            </TooltipHost>
            <TooltipHost content={`Elminar`}>
              <Icon
                iconName="Delete"
                style={{
                  cursor: "pointer",
                }}
                className={ThemeBase.classes.iconFont}
                onClick={() => {
                  setDataEdit(item);
                  openPanelEliminar();
                }}
              />
            </TooltipHost>
          </div>
        );
    }

    // const setTitleColumn = () => {
    //     let col: IColumn[] = [
    //         {
    //             key: 'column1',
    //             name: 'Codigo',
    //             fieldName: 'codigo',
    //             minWidth: 80,
    //             maxWidth: 120,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //         },
    //         {
    //             key: 'diasLaborables',
    //             name: 'Días Laborables',
    //             fieldName: 'diasLaborables',
    //             minWidth: 100,
    //             maxWidth: 100,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //         },
    //         {
    //             key: 'diasDescanso',
    //             name: 'Días de Descanso',
    //             fieldName: 'diasDescanso',
    //             minWidth: 100,
    //             maxWidth: 100,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //         },
    //         {
    //             key: 'column3',
    //             name: 'Guardia',
    //             fieldName: 'guardia',
    //             minWidth: 250,
    //             maxWidth: 250,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //         },
    //         {
    //             key: 'column4',
    //             name: 'Turno Día',
    //             fieldName: 'dia',
    //             minWidth: 100,
    //             maxWidth: 100,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //             onRender: (item: IRoster) => {
    //                 return <span>{item.dia ? 'Si' : 'No'}</span>
    //             }
    //         },
    //         {
    //             key: 'column5',
    //             name: 'Turno Noche',
    //             fieldName: 'noche',
    //             minWidth: 100,
    //             maxWidth: 100,
    //             isResizable: true,
    //             data: 'string',
    //             isPadded: true,
    //             onRender: (item: IRoster) => {
    //                 return <span>{item.noche ? 'Si' : 'No'}</span>
    //             }
    //         },
    //         {
    //             key: 'column6',
    //             name: 'Opciones',
    //             fieldName: '',
    //             minWidth: 98,
    //             maxWidth: 98,
    //             isResizable: true,
    //             isCollapsible: true,
    //             data: "string",
    //             onRender: (item: IRoster) => (
    //                 <>
    //                     <Stack horizontal tokens={stackTokensHorizontal}>
    //                         <>
    //                             <TooltipHost content={'Editar'}>
    //                                 <Icon iconName='Edit'
    //                                     style={{ cursor: 'pointer' }}
    //                                     className={ThemeBase.classNamesIcon.themeDarkAlt}
    //                                     onClick={() => {
    //                                         setDataEditRoster(item)
    //                                         openPanelEditar()
    //                                         /* setForm({
    //                                             ...item,
    //                                         })
    //                                         setIsAdd(false);
    //                                         setIsEdit(true);
    //                                         showModal(); */
    //                                     }}
    //                                 />
    //                             </TooltipHost>

    //                             <TooltipHost content={`Eliminar`}>
    //                                 <Icon iconName='Delete'
    //                                     style={{ cursor: 'pointer' }}
    //                                     className={ThemeBase.classNamesIcon.red10}
    //                                     onClick={() => {
    //                                         setDataEditRoster(item)
    //                                         openPanelEliminar()
    //                                     }}
    //                                 />
    //                                 {/* <Icon iconName='Delete'
    //                                     style={{ cursor: 'pointer' }}
    //                                     className={ThemeBase.classNamesIcon.red10}
    //                                     onClick={() => {
    //                                         setForm(item);
    //                                         setSelId(item.id);
    //                                         toggleEliminar();
    //                                     }}
    //                                 /> */}
    //                             </TooltipHost>
    //                         </>
    //                     </Stack>
    //                 </>
    //             ),
    //         },
    //     ];

    //     setColumn(col);
    // }

    const buttonLeft: IButtonGroup[] = [
        {
            onClick: () => {
                openPanelCrear()
            },
            text: "Nuevo",
        },
        {
            onClick: handleResetUpdate,
            text: "Actualizar",
        },
    ];

    // const _leftBar = () => {
    //     const _items: ICommandBarItemProps[] = [
    //         {
    //             ...IconHelper.ICON_ADD,
    //             onClick: openPanelCrear,
    //         },
    //         /*  {
    //              ...IconHelper.ICON_ADD,
    //              onClick: () => {
    //                  setForm(initialRoster);
    //                  setIsAdd(true);
    //                  setIsEdit(false);
    //                  showModal();
    //              },
    //          }, */
    //         {
    //             ...IconHelper.ICON_RELOAD,
    //             onClick: setup
    //         },
    //     ];
    //     return _items;
    // }

    // const _getFilter = () => {
    //     return searchParam.get(baseSearch) ?? '';
    // }

    /* Event */
    const _onChangeText = (type: string, event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event != undefined) {
            if (newValue != undefined) {
                switch (type) {
                    case 'codigo':
                        setForm({
                            ...form,
                            codigo: newValue,
                        })
                        break;
                    default:
                        break;
                }
            }
        }
    }

    const _onChangeCombo = (type: string, event: React.FormEvent<IComboBox>, option?: IComboBoxOption) => {
        if (event != undefined) {
            if (option != undefined) {
                switch (type) {
                    case 'guardia':
                        setForm({
                            ...form,
                            guardiaProgramacionId: option.key.toString(),
                        })
                        break;
                    default:
                        break;
                }
            }
        }
    }

    /* Event Filter */
    const _onChangeSearch = (ev?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
        console.log(newValue);

        if (newValue != undefined) {
            setSearchParam({
                [baseSearch]: newValue
            });
        }
    };

    const _onPressSearch = (newValue: string) => {
        setFilter({
            ...filter,
            search: newValue,
        })
    };

    const _onClearSearch = () => {
        setFilter({
            ...filter,
            search: '',
        })

        setSearchParam({
            [baseSearch]: ''
        });
    }

    return (
        <div className={style.body}>
            {/* <HeadingBar
                title='Rosters'
                subTitle='Gestión de Rosters'
                searchChange={_onChangeSearch}
                searchValue={_getFilter()}
                searchHandler={_onPressSearch}
                onClearHandler={_onClearSearch}
            ></HeadingBar> */}

            {/* <TableBase leftBar={_leftBar()} column={column} data={roster} isLoading={!hidden}></TableBase> */}
            <div>

            </div>
            <HeadingBar
                title="Rosters"
                subTitle={`Gestión de Rosters`}
                searchShow={false}
            />

            <TableComponent
                data={items}
                leftButtons={buttonLeft}
                // rightButton={buttonRight}
                column={_columns}
                paginacion={pagination}
                isLoading={loading}
                isSearch={true}
                onChangeSearch={onChangeSearch}
            />

            {/* Modal Registrar / Editar */}
            <Modal
                isOpen={isOpen}
                onDismiss={hideModal}
                isBlocking={false}
                containerClassName={ModalHelper.modalStyle.container}
            >
                <form>
                    <div className={ModalHelper.modalStyle.header}>
                        <span id={''}>{`${form.id ? 'Actualizar' : 'Nuevo'} Roster`}</span>
                        <IconButton
                            styles={ModalHelper.modalIconButtonStyles}
                            iconProps={ModalHelper.modalCancelIcon}
                            ariaLabel="Close popup modal"
                            onClick={hideModal}
                        />
                    </div>

                    <div className={ModalHelper.modalStyle.body} style={{ minWidth: 500 }}>
                        <Stack tokens={stackTokens}>
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5">
                                        <TextField
                                            label='Código'
                                            placeholder='Código'
                                            value={form.codigo ?? ''}
                                            onChange={(e, o) => _onChangeText('codigo', e, o)}
                                            autoComplete="off" />
                                    </div>

                                    <div className="ms-Grid-col ms-sm12 ms-md7 ms-lg7">
                                        <ComboBox
                                            label='Guardia'
                                            autoComplete='off'
                                            useComboBoxAsMenuWidth
                                            calloutProps={{ directionalHintFixed: true }}
                                            options={guardia}
                                            selectedKey={form ? form.guardiaProgramacionId : ''}
                                            onChange={(e, o) => _onChangeCombo('guardia', e, o)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <ButtonForm back={hideModal} register={crearRoster}></ButtonForm>
                        </Stack>
                    </div>
                </form>
            </Modal>

            <DialogBase isHidden={hideEliminar} subTitle='El Roster será eliminado permanentemente' tipo={DialogType.normal} toggleHidden={toggleEliminar} dependency={[]} confirm={eliminarRoster}></DialogBase>
            <PanelRosterCrear
                isOpen={isOpenCrear}
                onDismiss={closePanelCrear}
                reload={handleResetUpdate}
            />

                {dataEdit && isOpenEditar &&
            <PanelRosterActualizar
                isOpen={isOpenEditar}
                onDismiss={closePanelEditar}
                reload={handleResetUpdate}
                rosterData={dataEdit}
            />
        }
{
            dataEdit && isOpenEliminar &&
            <PanelRosterEliminar
                isOpen={isOpenEliminar}
                onDismiss={closePanelEliminar}
                reload={handleResetUpdate}
                rosterData={dataEdit}
            />
}
        </div>
    )
}